import { ReactNode } from 'react'
import { css } from '@emotion/react'

const containerStyle = (width: number) => css`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 32px;
  width: ${width}px;
  max-width: 100%;
`

export type Props = {
  width?: number
  children: ReactNode
}

export default function DetailViewContainer({
  width = 918,
  children,
}: Props) {
  return <div css={containerStyle(width)}>{children}</div>
}
